<template>
  <div class="login">
    <div class="w1000 center top">
      <div class="r-one">
        <!-- <div class="logo fl"><a href="/">返回首页</a></div> -->
        <div class="title">个人免费注册</div>
        <div class="title" style="margin-left: 150px">
          <router-link to="/enterpriseRegister">企业注册</router-link>
        </div>
        <!-- <div class="title" style="margin-left: 150px">
          <router-link to="/specialistRegister">专家注册</router-link>
        </div> -->
        <ul>
          <li><router-link to="/">返回首页</router-link></li>
          <li>
            <a>常见问题</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="panel panel-default container reg-box">
      <div class="panel-body mt50 mb20">
        <div class="col-xs-7 form form-horizontal">
          <!-- <form class=""> -->
          <input type="hidden" name="huodong" value="" />
          <div class="form-group" v-if="false">
            <label for="account" class="col-xs-3 control-label"><span style="color: #ff0000">*</span>用户名:</label>
            <div class="col-xs-8" style="display: flex">
              <input v-model="registerForm.userName" type="text" style="width: 70% !important"
                class="form-control Validform_error" placeholder="请输入您的用户名" />
              <a @click="checkUserName()" style="line-height: 35px; margin-left: 10px; font-size: 18px">校验用户名</a>
            </div>
          </div>
          <div class="form-group">
            <label for="account" class="col-xs-3 control-label"><span style="color: #ff0000">*</span>手机号:</label>
            <div class="col-xs-8">
              <input v-model="registerForm.telephone" type="text" class="form-control Validform_error"
                placeholder="请输入您的手机号" />
            </div>
          </div>
          <div class="form-group">
            <label for="password" class="col-xs-3 control-label"><span style="color: #ff0000">*</span>密码:</label>
            <div class="col-xs-8">
              <input type="password" v-model="registerForm.password" class="form-control" id="password" name="password"
                placeholder="请输入密码" />
              <div class="msg"></div>
            </div>
          </div>
          <div class="form-group">
            <label for="repassword" class="col-xs-3 control-label"><span style="color: #ff0000">*</span>重复密码:</label>
            <div class="col-xs-8">
              <input type="password" v-model="registerForm.confirmPassword" class="form-control" id="repassword"
                placeholder="请重复输入密码" />
              <div class="msg"></div>
            </div>
          </div>
          <div class="form-group">
            <label for="repassword" class="col-xs-3 control-label"><span style="color: #ff0000">*</span>姓名:</label>
            <div class="col-xs-8">
              <input type="text" class="form-control" v-model="registerForm.name" placeholder="请输入姓名" />
              <div class="msg"></div>
            </div>
          </div>
          <div class="form-group">
            <label for="repassword" class="col-xs-3 control-label"><span style="color: #ff0000">*</span>身份证号:</label>
            <div class="col-xs-8">
              <input type="text" class="form-control" v-model="registerForm.cardNum" placeholder="请输入身份证号" />
              <div class="msg"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-offset-2 col-xs-10">
              <div class="checkbox">
                <label><input type="checkbox" id="pact" name="pact" checked="checked" />
                  我已认真阅读并接受<a target="_blank"
                    href="/HBRC_Home/Article/about/id/1/code/4617.html">《石家庄国经会员服务协议》</a></label>
              </div>
              <div class="userreg_xy"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-offset-3">
              <div v-if="showRegister" type="button" style="width: 80px; height: 35px" class="btn btn-primary"
                id="dosubmit" @click="toRegister" name="dosubmit">
                立即注册
              </div>
              已有账号，去<router-link :to="{
                name: 'login',
                path: '/login',
                query: {
                  redirect: this.$route.query.redirect,
                },
              }" class="ltxt">登录</router-link>
            </div>
          </div>
          <!-- </form> -->
        </div>
        <div class="col-xs-3">
          <div class="well">
            石家庄市国经人力资源管理有限公司（Shijiazhuang Talent
            Group）是石家庄市国资委、市国投集团所属综合型人力资源服务机构。
            公司围绕“搭建政府平台，服务地方经济，稳健规范运营，塑造特色品牌”的经营宗旨，
            肩负着石家庄城市HR和打造知名人才高地重要抓手的使命，服务于石家庄市不断优化的人才生态系统，
            持续提升城市对人才的吸引力，激发人才的创新创业活力，为推动经济总量过万亿、实现弯道超车，
            加快建设现代化、国际化美丽省会城市提供了人才保障和智力支撑。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Register",
  data() {
    return {
      name: "",
      password: "",
      telephone: "",
      phoneCode: "",
      getCodeShow: true,
      seconds: 60,
      timer: null,
      showRegister: true,
      registerForm: {
        userName: "",
        password: "",
        confirmPassword: "",
        cardType: "1",
        cardNum: "",
        name: "",
        telephone: "",
      },
    };
  },
  created() {
    console.log("$route.params", this.$route.params);
  },
  methods: {
    checkUserName() {
      let _this = this;
      if (this.registerForm.userName == "") {
        this.$layer.alert("请输入用户名");
        return;
      }
      let params = {
        userName: _this.registerForm.userName,
      };
      _this.$api.user.checkUserName(params).then((res) => {
        if (res.code == this.$commons.RespCode.success) {
          this.$layer.alert("用户名可用");
        } else {
          this.$layer.alert("用户名已存在");
        }
      });
    },
    getCode() {
      let that = this;

      that.$api.user
        .getCode(that.telephone, "register")
        .then((res) => {
          if (res.errorCode == that.$commons.RespCode.success) {
            that.$layer.alert("发送成功");
            that.getCodeShow = false;
            that.timer = setInterval(function () {
              if (that.seconds <= 0) {
                that.getCodeShow = true;
                that.seconds = 60;
                clearInterval(that.timer);
                return;
              }
              that.seconds--;
            }, 1000);
          } else {
            that.$layer.alert(res.msg);
          }
        })
        .catch(() => { });
    },
    toRegister() {
      let _this = this;

      // if (!_this.registerForm.userName) {
      //   _this.$layer.alert("请填写用户名");
      //   return false;
      // }
      // 判断用户名的长度不得小于 2 ，如果用户名只有一个字符 会提示"不在指定范围"
      // if (_this.registerForm.userName.length < 2) {
      //   _this.$layer.alert("用户名过短");
      //   return false;
      // }
      if (!_this.registerForm.telephone) {
        _this.$layer.alert("请填写手机号");
        return false;
      } else {
        // "^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$"
        let myreg = new RegExp("^1[3,4,5,6,7,8,9][0-9]{9}$");
        if (!myreg.test(_this.registerForm.telephone)) {
          _this.$layer.alert("手机号格式错误");
          return false;
        }
      }
      if (!_this.registerForm.password) {
        _this.$layer.alert("请填写密码");
        return false;
      } else if (_this.registerForm.password.length < 6) {
        _this.$layer.alert("密码最少为6位");
        return false;
      }
      if (!_this.registerForm.confirmPassword) {
        _this.$layer.alert("请填写重复密码");
        return false;
      }
      if (_this.registerForm.password != _this.registerForm.confirmPassword) {
        _this.$layer.alert("密码与重复密码不一致");
        _this.registerForm.confirmPassword = "";
        return false;
      }
      if (!_this.registerForm.name) {
        _this.$layer.alert("请输入姓名");
        return false;
      } else {
        let nameReg = new RegExp("^[\u4e00-\u9fa5]{0,}$");
        if (!nameReg.test(_this.registerForm.name)) {
          _this.$layer.alert("姓名格式不正确!");
          return;
        }
      }
      if (!_this.registerForm.cardNum) {
        _this.$layer.alert("请填写身份证号");
        return false;
      } else if (!_this.$util.checkIdCard(_this.registerForm.cardNum)) {
        _this.$layer.alert("身份证号不正确");
        return false;
      }
      _this.registerForm.userName = _this.registerForm.cardNum
      let IdCard = _this.registerForm.cardNum;
      _this.registerForm.birthday =
        IdCard.substring(6, 10) +
        "-" +
        IdCard.substring(10, 12) +
        "-" +
        IdCard.substring(12, 14);
      if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
        _this.registerForm.gender = 1;
      } else {
        _this.registerForm.gender = 2;
      }
      _this.$layer.alert(
        "请确认姓名,手机号,身份证号!一经注册不可修改!",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          _this.$layer.close(index);
          _this.showRegister = false;
          delete _this.registerForm.confirmPassword;
          _this.$api.user.registerPc(_this.registerForm).then((res) => {
            // if (res.code == _this.$commons.RespCode.success) {
            _this.$layer.alert(res.msg, function (index1) {
              if (res.code == _this.$commons.RespCode.success) {
                _this.$router.push({
                  path: "/login",
                  query: {
                    redirect: _this.$route.query.redirect,
                  },
                });
              }
              _this.$layer.close(index1);
            });
            _this.showRegister = true;
            // } else {
            // _this.$layerMsg.error(res.msg);
            // }
          });
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/login/Register.vue